module.exports = __webpack_public_path__ + "img/w7.2e5cbb7d.png";